import React, { Component, Fragment } from 'react';

import EditableInput from '../../EditableInput';

import endpoints from '../../../lib/endpoints';
import ChatPlatformLinks from '../ChatPlatformLinks';

import UpCome from '../UpCome';

import { CHAT_LINKS, modifyChatLinks, getUsableLink, joinArray } from '../utils';

//TODO: No of treks run is hardcoded!

function PanelWithoutEdit({ title, dataKey, data }) {
  const value = {
    email_address: () => data,
    phone_numbers: () => joinArray(data),
    daily_wages: () => (data.amount ? data.amount : ''),
    experience_years: () => data,
    safety_trainings: () => joinArray(data),
    languages: () => joinArray(data),
    specialization: () => joinArray(data),
    expertise_regions: () => joinArray(data),
  };

  return (
    <div className="tb-row">
      <div className="key">{title}</div>
      <div className="value">{data ? value[dataKey]() : ''}</div>
    </div>
  );
}

export default class ProfessionalPannel extends Component {
  render() {
    const { urlUserId, isViewingOwnProfile, userData, updateUserData } = this.props;

    const modifiedChatLinks = userData.chat_platform_links
      ? modifyChatLinks(userData.chat_platform_links)
      : null;

    return (
      <Fragment>
        {isViewingOwnProfile ? (
          <Fragment>
            <div className="profile">
              <h2 className="bt-1">Contact Information</h2>
              {/* =================== chat platform links =============== */}
              <div className="tb-row">
                <div className="key">Chat Platform Links</div>
                <ChatPlatformLinks
                  value={modifiedChatLinks}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="chat_platform_links"
                  className="value"
                  updateData={updateUserData}
                >
                  <ul>
                    {modifiedChatLinks &&
                      CHAT_LINKS.map(link => (
                        <li key={link.patch_key}>
                          <div className="key">{link.title}</div>
                          <div className="value">
                            {modifiedChatLinks[link.patch_key].link ? (
                              <a
                                href={getUsableLink(
                                  modifiedChatLinks[link.patch_key].link,
                                  link.patch_key
                                )}
                                target="_blank"
                                rel="noopener"
                                className="link-social"
                              >
                                {modifiedChatLinks[link.patch_key].link}
                              </a>
                            ) : (
                              'Link not available'
                            )}
                          </div>
                        </li>
                      ))}
                  </ul>
                </ChatPlatformLinks>
              </div>
              {/* =================== Contact Info =============== */}
              <div className="tb-row">
                <div className="key">Contact Info</div>
                <EditableInput
                  value={userData.phone_numbers ? userData.phone_numbers : []}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="phone_numbers"
                  className="value"
                  patchObjDataType="array"
                  isCreatableSelect
                  placeholder="Enter your contact numbers."
                  updateData={updateUserData}
                >
                  <div className="value">{joinArray(userData.phone_numbers)}</div>
                </EditableInput>
              </div>
              <h2 className="bt-1">Professional Information</h2>

              {/* =================== Daily Wages =============== */}
              <div className="tb-row">
                <div className="key">Daily Wages (USD per day)</div>
                <EditableInput
                  value={userData.daily_wages ? userData.daily_wages : {}}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="daily_wages"
                  className="value"
                  patchObjDataType="object"
                  patchObjSchema="amount"
                  placeholder="Daily Wage in USD"
                  updateData={updateUserData}
                >
                  <div className="value">
                    {userData.daily_wages ? userData.daily_wages.amount : ''}
                  </div>
                </EditableInput>
              </div>
              {/* =================== Experience =============== */}
              <div className="tb-row">
                <div className="key">Experience (in Years)</div>
                <EditableInput
                  value={userData.experience_years ? userData.experience_years : ''}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="experience_years"
                  className="value"
                  patchObjDataType="number"
                  updateData={updateUserData}
                >
                  <div className="value">{userData.experience_years}</div>
                </EditableInput>
              </div>
              {/* =================== Safety training =============== */}
              <div className="tb-row">
                <div className="key">Safety Trainings</div>
                <EditableInput
                  value={userData.safety_trainings ? userData.safety_trainings : []}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="safety_trainings"
                  className="value"
                  patchObjDataType="array"
                  isCreatableSelect
                  placeholder="Enter trainings you have taken."
                  updateData={updateUserData}
                >
                  <div className="value">{joinArray(userData.safety_trainings)}</div>
                </EditableInput>
              </div>
              {/* =================== Languages =============== */}
              <div className="tb-row">
                <div className="key">Languages</div>
                <EditableInput
                  value={userData.languages ? userData.languages : []}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="languages"
                  className="value"
                  patchObjDataType="array"
                  placeholder="Enter languages you are fluent in."
                  isCreatableSelect
                  updateData={updateUserData}
                >
                  <div className="value">{joinArray(userData.languages)}</div>
                </EditableInput>
              </div>
              {/* =================== Specialization =============== */}
              <div className="tb-row">
                <div className="key">Specialization</div>
                <EditableInput
                  value={userData.specialization ? userData.specialization : []}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="specialization"
                  className="value"
                  isCreatableSelect
                  patchObjDataType="array"
                  placeholder="Enter your specializations."
                  updateData={updateUserData}
                >
                  <div className="value">{joinArray(userData.specialization)}</div>
                </EditableInput>
              </div>
              {/* =================== Expertise Regions =============== */}
              <div className="tb-row">
                <div className="key">Expertise Regions</div>
                <EditableInput
                  value={userData.expertise_regions ? userData.expertise_regions : []}
                  endpoint={endpoints.profile.patchUserData(urlUserId)}
                  patchKey="expertise_regions"
                  className="value"
                  patchObjDataType="array"
                  isCreatableSelect
                  placeholder="Enter trekking regions.."
                  updateData={updateUserData}
                >
                  <div className="value">{joinArray(userData.expertise_regions)}</div>
                </EditableInput>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="profile">
              <h2 className="bt-1">Contact Information</h2>
              <PanelWithoutEdit
                dataKey="phone_numbers"
                title="Contact Info"
                data={userData['phone_numbers']}
              />
              <h2 className="bt-1">Professional Information</h2>
              <PanelWithoutEdit
                dataKey="daily_wages"
                title="Daily Wages (USD per day)"
                data={userData['daily_wages']}
              />
              <PanelWithoutEdit
                dataKey="experience_years"
                title="Experience (in Years)"
                data={userData['experience_years']}
              />
              <PanelWithoutEdit
                dataKey="safety_trainings"
                title="Safety Trainings"
                data={userData['safety_trainings']}
              />
              <PanelWithoutEdit
                dataKey="languages"
                title="Languages"
                data={userData['languages']}
              />
              <PanelWithoutEdit
                dataKey="specialization"
                title="Specialization"
                data={userData['specialization']}
              />
              <PanelWithoutEdit
                dataKey="expertise_regions"
                title="Expertise Regions"
                data={userData['expertise_regions']}
              />
            </div>
          </Fragment>
        )}
        <hr />
        <UpCome
          isViewingOwnProfile={isViewingOwnProfile}
          data={userData.upcoming_treks}
          endpoint={endpoints.profile.patchUserData(urlUserId)}
          updateData={updateUserData}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/ProfilePannel/ProfessionalPannel.jsx